import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { CalendarDate } from "@sp-crm/core";

export type ReferralSourceVertical = "all" | "placement" | "homeCare";

interface ReferralSourceReportState {
    startDate: string;
    endDate: string;
    activePreset: string | null;
    sortField: string;
    sortAsc: boolean;
    viewMode: "flat" | "category";
    categoryFilter: string[];
    assignedUserFilter: string[];
    vertical: ReferralSourceVertical;
}

const now = CalendarDate.today;

const initialState: ReferralSourceReportState = {
    startDate: new CalendarDate(now.year, 1, 1).toString(),
    endDate: now.toString(),
    activePreset: null,
    sortField: "leadCount",
    sortAsc: false,
    viewMode: "flat",
    categoryFilter: [],
    assignedUserFilter: [],
    vertical: "all",
};

export const referralSourceReportSlice = createSlice({
    name: "referralSourceReport",
    initialState,
    reducers: {
        update: (state, action: PayloadAction<Partial<ReferralSourceReportState>>) => {
            return { ...state, ...action.payload };
        },
    },
});
